export default {
  zh: {
    'hostTitle': '公会',
    "inviteText": "邀请成员",
    "datecenterText": "数据中心",
    "copySuc":"复制成功",
    "menberTitle":"成员",
    "navTexg":"成员收到的硬币",
    "title":"",
    "memberApply":"成员",
  },
  en: {
    'hostTitle': 'Agency',
    "inviteText": "Invite member",
    "datecenterText": "Data center",
    "copySuc":"Copy successfully",
    "menberTitle":"Members",
    "navTexg":"Member received coins",
    "title":"Agency",
    "memberApply":"Member Apply",
  },
  ar: {
    'hostTitle': 'نقابة',
    "inviteText": "دعوة أعضاء",
    "datecenterText": "مركز البيانات",
    "copySuc":"تم النسخ بنجاح",
    "menberTitle":"عضو",
    "navTexg":"الكونزات التي حصل عليها الأعضاء",
    "title": "نقابة",
    "memberApply":"عضو تقدم بطلب",
  },
  tr: {
    'hostTitle': 'Ajans Sistemi',
    "inviteText": "Üyeyi Davet Et",
    "datecenterText": "Veri Merkezi",
    "copySuc":"Başarıyla kopyalandı",
    "menberTitle":"Üyeler",
    "navTexg":"Üye Altın Aldı",
    "title":'Ajans Sistemi',
    "memberApply":"Üye Başvurusu",
  },
  pt:{
    'hostTitle': 'Agência',
    "inviteText": "Convidar membro",
    "datecenterText": "Centro de dados",
    "copySuc": "Copiado com sucesso",
    "menberTitle": "Membros",
    "navTexg": "Membro recebeu moedas",
    "title": "Agência",
    "memberApply": "Aplicação de membro",
  },
  id:{
    'hostTitle': 'Agen',
    "inviteText": "Undang anggota",
    "datecenterText": "Pusat data",
    "copySuc": "Salin berhasil",
    "menberTitle": "Anggota",
    "navTexg": "Anggota menerima koin",
    "title": "Agen",
    "memberApply": "Pendaftaran Anggota",
  },
  uz: {
    'hostTitle': 'Agentlik',
    "inviteText": "A'zoni taklif qilish",
    "datecenterText": "Ma'lumotlar markazi",
    "copySuc": "Muvaffaqiyatli nusxalandi",
    "menberTitle": "A'zolar",
    "navTexg": "A'zo tangalar qabul qildi",
    "title": "Agentlik",
    "memberApply": "A'zo arizasi"
  },
  ru: {
    'hostTitle': 'Агентство',
    "inviteText": "Пригласить члена",
    "datecenterText": "Центр данных",
    "copySuc": "Успешно скопировано",
    "menberTitle": "Члены",
    "navTexg": "Член получил монеты",
    "title": "Агентство",
    "memberApply": "Заявка члена"
  },
  fa: {
    'hostTitle': 'آژانس',
    "inviteText": "دعوت عضو",
    "datecenterText": "مرکز داده",
    "copySuc": "با موفقیت کپی شد",
    "menberTitle": "اعضا",
    "navTexg": "عضو سکه دریافت کرد",
    "title": "آژانس",
    "memberApply": "درخواست عضویت"
  }
}



// WEBPACK FOOTER //
// src/pages/app/hobiHost/lang.js